export const QueryKey = 'appointments'
export const AppointmentChoiceEligibilityQueryKey =
  'appointment-choice-eligibility'
export const Appointments = '/api/v1/appointments'
export const AppointmentNotes = '/api/v1/appointment-notes'
export const AppointmentDefinitions =
  '/api/v1/sanity/timeline/appointmentDefinitions'
export const AppointmentChoiceEligibility =
  '/api/v1/appointments/appointment-choice-eligibility'
